const style = document.createElement('style');
style.type = "text/css";
document.head.appendChild(style);

export default function (context, value) {
    context.commit('set', value.MasterAgentSettings);
    let css = '';
    css += style_menu(context.state.menu);
    css += style_menuTop(context.state.menu);
    css += style_footer(context.state.footer);
    style.innerHTML = css;
}

function style_menu(data) {
    let css = '';
    css += '.mag-nav{background:' + data.background + ';}';
    css += '.mag-nav__menu{background:' + data.item.background + ';}';
    css += '.nav-link{color:' + data.item.color + ';}';
    css += '.nav-link:hover{color:' + data.itemHover.color + '; background: ' + data.itemHover.background + '}';
    css += '.nav-link.router-link-active{color:' + data.itemActive.color + '; background: ' + data.itemActive.background + '}';
    css += '.mag-nav__button{color:' + data.color + '; background: ' + data.background + '}';
    return css;
}

function style_menuTop(data) {
    let css = '';
    css += '.mag-header-wiki.active{color:' + data.item.background + '}';
    css += '.mag-header-wiki.active a{color:' + data.item.background + '}';
    css += '.mag-header-wiki.active .el-dropdown{color:' + data.item.background + '}';
    css += '.mag-header-video.active{color:' + data.item.background + '}';
    css += '.mag-header-video.active a{color:' + data.item.background + '}';
    css += '.mag-header-video.active .el-dropdown{color:' + data.item.background + '}';
    return css;
}

function style_footer(data) {
    let css = '';
    css += '.mag-footer{color: #ccd2cd; background: ' + data.background + '}';
    return css;
}
